import * as yup from "yup";
import { hasMaxDecimals } from "@/utils/format/regex/just-decimal";

// Upsell credits are fractional (PO credits are decimal(10,2) in the backend),
// but no more than 2 decimals — the backend rejects those with a 400. The check
// runs on the string form of the number: arithmetic on the value is unreliable
// (1.15 * 100 === 114.99999999999999).
const withinDecimalLimit = (value?: number) =>
  value === undefined || hasMaxDecimals(String(value));

export const UpsellSchema = yup.object().shape({
  upsellOption: yup
    .number()
    .typeError("Opção de upsell é obrigatória e deve ser um número")
    .required("Opção de upsell é obrigatória")
    .min(1, "Opção de upsell deve ser no mínimo 1")
    .test(
      "max-decimals",
      "Opção de upsell deve ter no máximo 2 casas decimais",
      withinDecimalLimit,
    ),
  upsellProRataOption: yup
    .number()
    .min(1, "Opção de pro rata deve ser no mínimo 1")
    .test(
      "max-decimals",
      "Opção de pro rata deve ter no máximo 2 casas decimais",
      withinDecimalLimit,
    ),
});
